import React, { useState } from "react";
import {
  Card,
  List,
  Typography,
  Skeleton,
  Button,
  Modal,
  Input,
  message,
} from "antd";
import { ExclamationCircleOutlined, RedoOutlined } from "@ant-design/icons";
import { externalTransferBalance } from "../api/transactions/transactionRequest";
import PermissionRender from "./PermissionRender";

const { Text } = Typography;
const { confirm } = Modal;

const PositiveBalanceUsers = ({
  users,
  loading,
  currentUser,
  refreshUserBalance,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [amount, setAmount] = useState("");
  const [isTransferring, setIsTransferring] = useState(false);

  // Function to show the modal for transferring to the bank
  const showModal = (user) => {
    setSelectedUser(user);
    setIsModalVisible(true);
  };

  // Function to handle transferring to the bank
  const handleTransferToBank = async () => {
    if (!amount || isNaN(amount)) {
      message.error("Veuillez entrer un montant valide.");
      return;
    }

    setIsTransferring(true);

    try {
      // Call the external transfer API
      const data = await externalTransferBalance({
        amount: parseFloat(amount),
      });

      if (data) {
        message.success("Transfert à la banque effectué avec succès!");
        setIsModalVisible(false);
        setAmount("");
        refreshUserBalance();
      } else {
        message.error("Échec du transfert à la banque.");
      }
    } catch (error) {
      message.error("Une erreur s'est produite. Veuillez réessayer.");
    } finally {
      setIsTransferring(false);
    }
  };

  // Confirmation dialog before transferring to the bank
  const confirmTransferToBank = () => {
    confirm({
      title: "Êtes-vous sûr de vouloir transférer ce montant à la banque?",
      icon: <ExclamationCircleOutlined />,
      content: `Cela transférera ${amount} dhs à la banque pour ${selectedUser.full_name}.`,
      onOk: handleTransferToBank,
      onCancel() {
        console.log("Annulé");
      },
    });
  };

  return (
    <Card
      className="shadow-sm"
      title={
        <div className="flex justify-between">
          <Text strong className="text-lg">
            Utilisateurs avec Solde
          </Text>

          <Button icon={<RedoOutlined />} onClick={refreshUserBalance} />
        </div>
      }
    >
      <List
        itemLayout="horizontal"
        dataSource={users}
        renderItem={(user) => (
          <List.Item
            actions={[
              user.id_agent === currentUser.id_agent && (
                <PermissionRender
                  requiredPermission={["transactions", "external_transfer"]}
                >
                  <Button type="link" onClick={() => showModal(user)}>
                    Transférer à la banque
                  </Button>
                </PermissionRender>
              ),
            ]}
          >
            <Skeleton loading={loading} active avatar paragraph={{ rows: 1 }}>
              <List.Item.Meta
                title={user.full_name}
                description={`Solde: ${user.balance}`}
              />
            </Skeleton>
          </List.Item>
        )}
      />

      {/* Modal for Transferring to Bank */}
      <Modal
        title={`Transférer à la banque pour ${selectedUser?.full_name}`}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalVisible(false)}>
            Annuler
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={confirmTransferToBank}
            loading={isTransferring}
            disabled={!amount || isNaN(amount)}
          >
            Transférer
          </Button>,
        ]}
      >
        <Input
          placeholder="Entrez le montant à transférer"
          value={amount}
          type="number"
          min={1}
          onChange={(e) => setAmount(e.target.value)}
        />
      </Modal>
    </Card>
  );
};

export default PositiveBalanceUsers;
